import axios from "axios";
import routes from "../app/routes";

export const coachPoolActions = {
  loadCoachPools: (dispatch) => {
    axios.get(routes.api.coach_pools.index).then((resp) => {
      dispatch({ type: "loadCoachPools", coachPools: resp.data.data });
    });
  },
  showCreateForm: (dispatch) => {
    dispatch({ type: "showModal" });
  },
  hideModal: (dispatch) => {
    dispatch({ type: "hideModal" });
  },
  createCoachPool: (dispatch, values, successCallback, errorCallback) => {
    axios
      .post(routes.api.coach_pools.create, values)
      .then((resp) => {
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },
  editCoachPool: (id) => {
    document.location.href = routes.api.coach_pools.edit(id);
  },
  viewCoachPool: (id) => {
    document.location.href = routes.api.coach_pools.show(id);
  },
  deleteCoachPool: (dispatch, coachPoolId) => {
    axios.delete(routes.api.coach_pools.destroy(coachPoolId)).then((resp) => {
      dispatch({
        type: "deleteCoachPool",
        coachPoolId: coachPoolId,
      });
    });
  },
  duplicateCoachPool: (dispatch, coachPoolId, callback) => {
    axios.post(routes.api.coach_pools.duplicate(coachPoolId)).then((resp) => {
      callback(resp.data.data);
    });
  },
  showTeams: (dispatch, coachPoolId) => {},
};
